export default function useMenu() {
  const router = useRouter()
  const { t, te } = useI18n({ useScope: 'global' })

  const settingsStore = useSettingsStore()
  const menuStore = useMenuStore()

  function generateI18nTitle(titleOrKey: string | (() => any) = t('app.route.undefined')) {
    return typeof titleOrKey === 'function'
      ? titleOrKey()
      : te(titleOrKey)
        ? t(titleOrKey)
        : titleOrKey
  }

  function switchTo(index: number) {
    menuStore.setActived(index)
    const selectedMenus = menuStore.allMenus[index]?.children || []
    const containsPath = (menus: typeof selectedMenus, target: string): boolean => menus.some((item) => {
      if (item.path === target) {
        return true
      }
      return item.children ? containsPath(item.children, target) : false
    })
    const shouldInitializeAiEmployeeConsole = settingsStore.settings.menu.mode !== 'single'
      && (containsPath(selectedMenus, '/crae-ai-employee') || containsPath(selectedMenus, '/newcrae-ai-employee'))
    if (
      shouldInitializeAiEmployeeConsole
      || settingsStore.settings.menu.mainMenuClickMode === 'jump'
      || (settingsStore.settings.menu.mainMenuClickMode === 'smart' && menuStore.sidebarMenusHasOnlyMenu)
    ) {
      router.push(menuStore.sidebarMenusFirstDeepestPath)
    }
  }

  return {
    generateI18nTitle,
    switchTo,
  }
}
